import React from "react";
import Layout from "../Layout";
import NextHead from "../Seo/NextHead";
import BreadcrumbComponent from "../UserInterface/BreadcrumbComponent";
import HeadingComponent from "../UserInterface/HeadingComponent";
import LayoutCenter from "../UserInterface/LayoutCenter";
import Topics from "./Topics";
import { HEADER_NONE } from "../../utils/constanta";
import DefaultContactInformation from "../UserInterface/DefaultContactInformation";

type TopicWrapperProps = {
  pageTitle: string;
  asPath: string;
  description: any;
  breadcrumb: any;
  topicBreadcrumb: any;
  questions: any;
  topicId: any;
  children: any;
  header: any;
};

const TopicWrapper = ({
  pageTitle,
  asPath,
  description,
  breadcrumb,
  topicBreadcrumb,
  questions,
  topicId,
  children,
  header,
}: TopicWrapperProps) => {
  const headerNav = header ? JSON.parse(header) : true;

  return (
    <Layout headerTypeProps={!headerNav && HEADER_NONE}>
      <NextHead
        title={pageTitle}
        url={asPath}
        description={description}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent
        items={topicBreadcrumb}
        visibility={!headerNav}
      ></BreadcrumbComponent>
      <HeadingComponent
        headingText="Pertanyaan Umum"
        margin="0px 0px 20px 0px"
      ></HeadingComponent>
      <LayoutCenter alignItem>
        <div className="topics-qna-container">
          <div className="topics-wrapper">
            <Topics dataQuestions={questions} topicId={topicId} />
          </div>
          <div className="qna-wrapper">{children}</div>
        </div>
      </LayoutCenter>
      <DefaultContactInformation />

      <style jsx>{`
        .topics-qna-container {
          display: grid;
          grid-template-columns: 1fr 2fr;
          grid-column-gap: 25px;
        }

        @media only screen and (max-width: 600px) {
          .topics-qna-container {
            grid-template-columns: 1fr;
            display: block;
          }
          .topics-wrapper {
            display: none;
            order: 2;
          }
          .qna-wrapper {
            order: 1;
          }
        }
      `}</style>
    </Layout>
  );
};
export default TopicWrapper;
